import { AbstractControl, Validators } from '@angular/forms';
import { IAccountValidator } from './account-validator';

export class GenericAccountValidator implements IAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'Este campo es requerido'
        },
        'en-US': {
            bad_email: 'This field is required'
        }
    };
    protected static label: any = {
        'es-AR': 'Cuenta de',
        'en-US': 'Account of'
    };
    protected static placeholder: any = {
        'es-AR': '',
        'en-US': ''
    };
    protected static lang: string = 'es-AR';
    public getLabelToAccountType(): string {
        return GenericAccountValidator.label[GenericAccountValidator.lang] ?? GenericAccountValidator.label['es-AR'];
    }

    public setLang(lang: string): this {
        GenericAccountValidator.lang = lang;

        return this;
    }

    public getPlaceholderToAccountType(): string {
        return '';
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any = GenericAccountValidator.errors[GenericAccountValidator.lang] ?? GenericAccountValidator.errors['es-AR'];
        if (Validators.required(control) !== null) {
            return { forbiddenName: error.bad_email };
        }

        return null;
    }
}
